import React from 'react';
import { Typography } from 'antd';
import type { ProjectionFreshnessStatusV0 } from '@shared/projection/ProjectionProfile';
import {
  PRIMITIVE_AUTHORITY_FLAGS,
  type PrimitivePresentationState,
} from './primitiveSurfaceState';
import { PrimitiveSurfaceFrame } from './PrimitiveSurfaceFrame';
import styles from './primitives.module.css';

const { Text } = Typography;

export interface StatusSummaryProps {
  readonly presentationState: PrimitivePresentationState;
  /** Canonical or operator-facing state label — not authority. */
  readonly stateLabel?: string;
  readonly stateToken?: string;
  readonly freshness?: ProjectionFreshnessStatusV0 | string | null;
  readonly grantsAuthority?: false;
  readonly grantsApproval?: false;
  readonly 'data-testid'?: string;
}

export function StatusSummary(props: StatusSummaryProps): React.ReactElement {
  const grantsAuthority = props.grantsAuthority ?? PRIMITIVE_AUTHORITY_FLAGS.grantsAuthority;
  const grantsApproval = props.grantsApproval ?? PRIMITIVE_AUTHORITY_FLAGS.grantsApproval;
  if (grantsAuthority !== false || grantsApproval !== false) {
    throw new Error('StatusSummary must keep grantsAuthority/grantsApproval=false');
  }

  return (
    <PrimitiveSurfaceFrame
      title="상태 요약"
      presentationState={props.presentationState}
      emptyMessage="상태 정보가 없습니다."
      data-testid={props['data-testid'] ?? 'status-summary'}
      aria-label="상태 요약"
    >
      <div className={styles.primitiveStack}>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>상태</span>
          <Text>
            <strong data-state-token={props.stateToken}>{props.stateLabel ?? 'UNKNOWN'}</strong>
          </Text>
        </div>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>신선도</span>
          <Text>{props.freshness ?? 'UNKNOWN'}</Text>
        </div>
        <Text type="secondary">상태 표시는 권한이 아닙니다.</Text>
      </div>
    </PrimitiveSurfaceFrame>
  );
}
